const SIX_MONTH_GIFT = 'SIX_MONTH_GIFT';
const TWELVE_MONTH_GIFT = 'TWELVE_MONTH_GIFT';
const LIFETIME_GIFT = 'LIFETIME_GIFT';

export const giftData = {
    [SIX_MONTH_GIFT]: {
    id: 0,
    shopifyUrl: '6-month-gift-subscription-to-codespark-academy',
    header: '6 Months',
    price: '$59.95',
    monthlyPrice: '$9.99/month',
    percentOff: null,
    bestValue: false,
    },
    [TWELVE_MONTH_GIFT]: {
    id: 1,
    shopifyUrl: '12-month-gift-to-codespark-academy-nonus',
    header: '12 Months',
    price: '$99.99',
    monthlyPrice: '$8.33/month*',
    percentOff: '16% OFF**',
    bestValue: false,
    },
    [LIFETIME_GIFT]: {
    id: 2,
    shopifyUrl: 'lifetime-gift-to-codespark-academy-1',
    header: 'Lifetime',
    price: '$199.99',
    monthlyPrice: '$5.56/month*',
    percentOff: '44% OFF**',
    bestValue: true,
    },
};
